import CommunitiesList from "./communitiesList";

export default CommunitiesList;